"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8557],{

/***/ 36752:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/profile-new.4ce45369.svg","height":21,"width":22});

/***/ }),

/***/ 6643:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/the_volte_logo_black.aa1c8b7c.svg","height":329,"width":1314});

/***/ }),

/***/ 14077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ defaultContext; },
/* harmony export */   "p": function() { return /* binding */ MenuContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var defaultContext = {
    mainMenu: {
        __typename: "Menu",
        items: []
    },
    footer: {
        id: "1",
        __typename: "Menu",
        items: []
    },
    siteSetting: {
        socialMedia: [],
        siteCountryName: "Australia",
        shortDateFormat: "DD/MM/YYYY"
    }
};
var MenuContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
MenuContext.displayName = "MenuContext";


/***/ }),

/***/ 49535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ legacy_NotFound; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/intl-shim.tsx
var intl_shim = __webpack_require__(47355);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/legacy/NotFound/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: $spacer * 2 $spacer;\n\n  .header {\n    font-size: 15rem;\n    font-family: "Montserrat";\n    font-weight: 900;\n    line-height: 100%;\n    color: $blue;\n    padding-bottom: 20px;\n\n    @media (max-width: $small-screen) {\n      font-size: 9rem;\n    }\n  }\n\n  .ruler {\n    background: $blue;\n    min-width: $spacer * 10;\n    height: 2px;\n    margin-top: $spacer;\n    margin-bottom: $spacer * 3;\n  }\n\n  .message {\n    @media (max-width: $small-screen) {\n      p {\n        display: inline;\n      }\n    }\n  }\n\n  .button {\n    margin: $spacer * 2 0;\n    min-width: 88%;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var NotFound = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
/* harmony default export */ var styles = ({
    NotFound: NotFound
});

;// CONCATENATED MODULE: ./src/components/legacy/NotFound/index.tsx







var NotFound_NotFound = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles.NotFound, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                className: "header",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                    defaultMessage: "404"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "ruler"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "message",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                                defaultMessage: "We can’t seem to find a page you are looking for!"
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                                defaultMessage: "You may have mistyped the address or the page may have moved."
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                            defaultMessage: "We’re sorry for the error and hope you’ll have a good day."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "button",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                            testingContext: "404pageGotoHomeButton",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                                defaultMessage: "Back to home"
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var legacy_NotFound = (NotFound_NotFound);


/***/ }),

/***/ 92291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddressSummary": function() { return /* reexport */ legacy_AddressSummary; },
  "Breadcrumbs": function() { return /* reexport */ legacy_Breadcrumbs; },
  "CartTable": function() { return /* reexport */ CartTable_Table; },
  "CheckoutLogin": function() { return /* reexport */ legacy_CheckoutLogin; },
  "Loader": function() { return /* reexport */ legacy_Loader; },
  "MainMenu": function() { return /* reexport */ MainMenu; },
  "MenuDropdown": function() { return /* reexport */ MenuDropdown; },
  "Message": function() { return /* reexport */ legacy_Message; },
  "MetaConsumer": function() { return /* reexport */ consumer; },
  "MetaWrapper": function() { return /* reexport */ Meta_MetaWrapper; },
  "NavLink": function() { return /* reexport */ NavLink; },
  "NextQueryParamProvider": function() { return /* reexport */ NextQueryParamProvider; },
  "NotFound": function() { return /* reexport */ NotFound/* default */.Z; },
  "Overlay": function() { return /* reexport */ legacy_Overlay_Overlay; },
  "OverlayContext": function() { return /* reexport */ OverlayContext; },
  "OverlayManager": function() { return /* reexport */ Manager; },
  "OverlayProvider": function() { return /* reexport */ provider; },
  "OverlayTheme": function() { return /* reexport */ OverlayTheme; },
  "OverlayType": function() { return /* reexport */ OverlayType; },
  "SocialMediaIcon": function() { return /* reexport */ legacy_SocialMediaIcon; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/hooks/useLogin.ts
var useLogin = __webpack_require__(67083);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/legacy/CheckoutLogin/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    h3 {\n      text-align: center;\n      font-size: ",
        ";\n      padding-top: 0.5rem;\n      font-weight: 400;\n    }\n\n    h2 {\n      text-align: center;\n      font-size: ",
        ";\n      padding-top: 0.5rem;\n      font-weight: 400;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var CheckoutLoginDiv = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), theme.checkoutTitle.fontSize, theme.pageTitle.fontSize);
});
var InfoP = emotion_styled_browser_esm/* default.p */.Z.p(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), theme.infoText.fontSize);
});

;// CONCATENATED MODULE: ./src/components/legacy/CheckoutLogin/index.tsx








var CheckoutLogin = function() {
    var user = (0,lib.useAuth)().user;
    var ref = (0,useLogin/* default */.Z)(), login = ref.login, register = ref.register;
    return user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Redirect, {
        url: paths/* paths.checkout */.H.checkout
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CheckoutLoginDiv, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                        children: "Account Required"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoP, {
                        children: "You must login to continue and place your order"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                    columns: 2,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                            testingContext: "CheckoutLoginButton",
                            onClick: login,
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                            testingContext: "CheckoutLoginButton",
                            onClick: register,
                            children: "Register"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                    onClick: login,
                    children: "Forgot password?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
            ]
        })
    });
};
/* harmony default export */ var legacy_CheckoutLogin = (CheckoutLogin);

;// CONCATENATED MODULE: ./src/components/legacy/Loader/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @keyframes firstItem {\n    0% {\n      left: 0;\n    }\n    12.5% {\n      left: 2rem;\n    }\n    25% {\n      left: 4rem;\n    }\n    37.5% {\n      left: 2rem;\n    }\n    50% {\n      left: 0;\n    }\n    100% {\n      left: 0;\n    }\n  }\n\n  @keyframes secondItem {\n    0% {\n      left: 2rem;\n    }\n    12.5% {\n      left: 2rem;\n    }\n    25% {\n      left: 4rem;\n    }\n    37.5% {\n      left: 2rem;\n    }\n    62.5% {\n      left: 2rem;\n    }\n    75% {\n      left: 0;\n    }\n    87.5% {\n      left: 2rem;\n    }\n    100% {\n      left: 2rem;\n    }\n  }\n\n  @keyframes thirdItem {\n    0% {\n      left: 4rem;\n    }\n    50% {\n      left: 4rem;\n    }\n    62.5% {\n      left: 2rem;\n    }\n    75% {\n      left: 0;\n    }\n    87.5% {\n      left: 2rem;\n    }\n    100% {\n      left: 4rem;\n    }\n  }\n\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: $spacer 0;\n\n  &__items {\n    position: relative;\n    width: 5rem;\n    height: 1rem;\n    margin: 0 auto;\n\n    span {\n      background-color: $blue;\n      width: 1rem;\n      height: 1rem;\n      border-radius: 1rem;\n      position: absolute;\n\n      &:nth-child(1) {\n        left: 0;\n        animation: firstItem 2s infinite;\n        animation-timing-function: linear;\n      }\n\n      &:nth-child(2) {\n        left: 2rem;\n        animation: secondItem 2s infinite;\n        animation-timing-function: linear;\n      }\n\n      &:nth-child(3) {\n        right: 0;\n        animation: thirdItem 2s infinite;\n        animation-timing-function: linear;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Loader = emotion_styled_browser_esm/* default.div */.Z.div(styles_templateObject());
/* harmony default export */ var styles = ({
    Loader: Loader
});

;// CONCATENATED MODULE: ./src/components/legacy/Loader/index.tsx



var Loader_Loader = function(param) {
    var full = param.full;
    var getHeight = function() {
        var ref, ref1;
        var headerHeight = document.getElementById("header") && ((ref = document === null || document === void 0 ? void 0 : document.getElementById("header")) === null || ref === void 0 ? void 0 : ref.offsetHeight);
        var footerHeight = document.getElementById("footer") && ((ref1 = document === null || document === void 0 ? void 0 : document.getElementById("footer")) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight);
        return window.innerHeight - headerHeight - footerHeight;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles.Loader, {
        style: full && {
            height: getHeight()
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "loader__items",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {})
            ]
        })
    });
};
/* harmony default export */ var legacy_Loader = (Loader_Loader);

// EXTERNAL MODULE: ./src/hooks/useHandlerWhenClickedOutside.tsx + 1 modules
var useHandlerWhenClickedOutside = __webpack_require__(46635);
// EXTERNAL MODULE: ./src/globalStyles/variables.ts
var variables = __webpack_require__(12864);
// EXTERNAL MODULE: ./src/images/profile-new.svg
var profile_new = __webpack_require__(36752);
;// CONCATENATED MODULE: ./src/components/legacy/MenuDropdown/MenuDropdown.tsx
/* eslint-disable jsx-a11y/mouse-events-have-key-events */ 






var MenuDropdown = function(param) {
    var content = param.content, label = param.label;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var setElementRef = (0,useHandlerWhenClickedOutside/* useHandlerWhenClickedOutside */.s)(function() {
        setIsActive(false);
    }).setElementRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        "data-test": "userButton",
        tabIndex: 0,
        m: 0,
        ref: setElementRef(),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                "aria-label": "toggle profile menu",
                _hover: {
                    cursor: "pointer"
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                onClick: function() {
                    return setIsActive(!isActive);
                },
                marginRight: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "black",
                        padding: "0.35rem 0.1rem",
                        textTransform: "uppercase",
                        textAlign: "right",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "90px",
                        flex: "none",
                        lineHeight: "inherit",
                        marginRight: 1,
                        children: label
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MenuIcon, {
                        dataTest: "desktopMenuToggleProfileIcon",
                        svgSrc: profile_new/* default.src */.Z.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                onClick: function() {
                    return setIsActive(false);
                },
                position: "relative",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    display: isActive ? "block" : "none",
                    position: "absolute",
                    top: "3px",
                    "box-shadow": variables/* messageshadow */.Kt,
                    backgroundColor: variables/* white */.ix,
                    zIndex: isActive ? 2 : "initial",
                    boxShadow: "0px 6px 15px 3px #00000040;",
                    children: content
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/legacy/MenuDropdown/index.tsx


// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/images/x.svg
var x = __webpack_require__(13337);
;// CONCATENATED MODULE: ./src/components/legacy/Message/styles.ts

function Message_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: $message-width;\n  padding: $message-padding;\n  background-color: $message-background-color;\n  box-shadow: $message-shadow;\n  position: fixed;\n  bottom: $message-right-position;\n  right: $message-botttom-position;\n  border-left: $message-border-left;\n\n  &--hidden {\n    display: none;\n  }\n\n  &__status-success {\n    border-color: $message-success-color;\n  }\n\n  &__status-error {\n    border-color: $message-error-color;\n  }\n\n  &__title {\n    text-transform: $message-title-transform;\n    font-weight: $message-title-weight;\n    margin: $message-title-margin;\n  }\n\n  &__content {\n    margin: $message-content-margin;\n  }\n\n  &__close-icon {\n    position: absolute;\n    top: 1.8rem;\n    right: 1.5rem;\n    transition: 0.3s;\n\n    svg * {\n      transition: 0.3s;\n    }\n\n    &:hover {\n      svg * {\n        fill: $gray;\n      }\n    }\n  }\n"
    ]);
    Message_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Message = emotion_styled_browser_esm/* default.div */.Z.div(Message_styles_templateObject());
/* harmony default export */ var Message_styles = ({
    Message: Message
});

;// CONCATENATED MODULE: ./src/components/legacy/Message/index.tsx





var Message_Message = function(param) {
    var title = param.title, _status = param.status, status = _status === void 0 ? "neutral" : _status, children = param.children, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Message_styles.Message, {
        className: "message__status-".concat(status),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                className: "message__title",
                children: title
            }),
            children ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "message__content",
                children: children
            }) : null,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                src: x/* default.src */.Z.src,
                className: "message__close-icon",
                onClick: onClose
            })
        ]
    });
};
/* harmony default export */ var legacy_Message = (Message_Message);

// EXTERNAL MODULE: ./src/components/legacy/NotFound/index.tsx + 1 modules
var NotFound = __webpack_require__(49535);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.mjs
var bi = __webpack_require__(61121);
// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.mjs
var fa6 = __webpack_require__(86204);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/components/atoms/DynamicReactIcon/index.tsx





var DynamicReactIcon = function(param) {
    var _iconFamily = param.iconFamily, iconFamily = _iconFamily === void 0 ? "fa6" : _iconFamily, icon = param.icon, size = param.size;
    var ic = icon || "FaRegCircle";
    var Icons = {
        // Add other icon families as needed
        fa6: dynamic_default()(function() {
            return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 86204)).then(function(mod) {
                return mod[ic];
            }).then(function(e) {
                return e === undefined ? fa6.FaRegCircle : e;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(null /* weak dependency, without id */)
                    ];
                }
            }
        }),
        fi: dynamic_default()(function() {
            return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2777)).then(function(mod) {
                return mod[ic];
            }).then(function(e) {
                return e === undefined ? fi.FiCircle : e;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(null /* weak dependency, without id */)
                    ];
                }
            }
        }),
        bi: dynamic_default()(function() {
            return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61121)).then(function(mod) {
                return mod[ic];
            }).then(function(e) {
                return e === undefined ? bi.BiCircle : e;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(null /* weak dependency, without id */)
                    ];
                }
            }
        })
    };
    var Icon = iconFamily && icon ? Icons[iconFamily] : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
            size: size
        })
    });
};

;// CONCATENATED MODULE: ./src/components/legacy/SocialMediaIcon/index.tsx



var SocialMediaIcon = function(param) {
    var social = param.social, target = param.target;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: social.link,
        target: target || "_blank",
        "aria-label": social.ariaLabel,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicReactIcon, {
            icon: social.icon,
            iconFamily: social.iconFamily,
            size: 20
        })
    });
};
/* harmony default export */ var legacy_SocialMediaIcon = (SocialMediaIcon);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/intl-shim.tsx
var intl_shim = __webpack_require__(47355);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/components/legacy/AddressSummary/styles.ts

function AddressSummary_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  line-height: 1.5;\n  font-size: ",
        ";;\n\n  padding-top: 1.5rem;\n  padding-bottom: 2rem;\n\n  strong {\n    font-weight: ",
        ";;\n    display: inline-block;\n    padding-bottom: ",
        "; * 0.5;\n  }\n"
    ]);
    AddressSummary_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AddressSummary = emotion_styled_browser_esm/* default.p */.Z.p(AddressSummary_styles_templateObject(), function(props) {
    return props.theme.colors.grayDark;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.boldFontWeight;
}, function(props) {
    return props.theme.spacing.spacer;
});
/* harmony default export */ var AddressSummary_styles = ({
    AddressSummary: AddressSummary
});

;// CONCATENATED MODULE: ./src/components/legacy/AddressSummary/index.tsx







var AddressSummary_AddressSummary = function(param) {
    var address = param.address, _forceFirstName = param.forceFirstName, forceFirstName = _forceFirstName === void 0 ? "" : _forceFirstName, email = param.email, paragraphRef = param.paragraphRef;
    if (address) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddressSummary_styles.AddressSummary, {
            ref: paragraphRef,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    children: "".concat(forceFirstName || address.firstName, " ").concat(address.lastName)
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                address.companyName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        address.companyName,
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                    ]
                }),
                address.streetAddress1,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                address.streetAddress2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        address.streetAddress2,
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                    ]
                }),
                address.city,
                ", ",
                address.postalCode,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                address.countryArea && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        address.countryArea,
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                    ]
                }),
                address.country.country,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                address.phone && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.phoneNumber */.i4.phoneNumber), {
                            values: {
                                phone: address.phone
                            }
                        })),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                    ]
                }),
                email && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        email,
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                    ]
                })
            ]
        });
    }
    if (email) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressSummary_styles.AddressSummary, {
            ref: paragraphRef,
            children: email
        });
    }
    return null;
};
/* harmony default export */ var legacy_AddressSummary = (AddressSummary_AddressSummary);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./src/utils/misc.ts
var misc = __webpack_require__(48830);
;// CONCATENATED MODULE: ./src/components/legacy/CartTable/CostRow.tsx


var CostRow = function(param) {
    var mediumScreen = param.mediumScreen, heading = param.heading, cost = param.cost;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                colSpan: mediumScreen ? 4 : 3,
                className: "cost",
                children: heading
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                colSpan: 1,
                style: {
                    textAlign: "right"
                },
                children: cost
            })
        ]
    });
};
/* harmony default export */ var CartTable_CostRow = (CostRow);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(47930);
// EXTERNAL MODULE: ./src/components/containers/index.ts + 1 modules
var containers = __webpack_require__(71547);
// EXTERNAL MODULE: ./src/components/molecules/index.ts + 68 modules
var molecules = __webpack_require__(27706);
;// CONCATENATED MODULE: ./src/components/legacy/CartTable/ProductRow.tsx









var ProductRow = function(param) {
    var mediumScreen = param.mediumScreen, processing = param.processing, line = param.line, reservation = param.reservation;
    var productUrl = line.product ? (0,react_router/* generatePath */.Gn)(paths/* paths.product */.H.product, {
        slug: line.product.slug
    }) : null;
    var rentalStart = reservation === null || reservation === void 0 ? void 0 : reservation.rentalStartDate;
    var rentalEnd = reservation === null || reservation === void 0 ? void 0 : reservation.rentalEndDate;
    var rentalStartDateFormat = (0,isValid/* default */.Z)(new Date(rentalStart)) && (0,format/* default */.Z)(new Date(rentalStart), "dd LLL yyyy");
    var rentalEndDateFormat = (0,isValid/* default */.Z)(new Date(rentalEnd)) && (0,format/* default */.Z)(new Date(rentalEnd), "dd LLL yyyy");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
        className: processing ? "row--processing" : undefined,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                children: productUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "product-row",
                    children: [
                        mediumScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: productUrl,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "thumbnail",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* Thumbnail */.pl, {
                                        heightPixels: 50,
                                        widthPixels: 50,
                                        source: line.product
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: productUrl,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                children: line.product.name
                            })
                        })
                    ]
                }) : line.name
            }),
            mediumScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                    taxedMoney: line.totalPrice
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                children: line.attributes && line.attributes.map(function(param) {
                    var attribute = param.attribute, values = param.values;
                    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === "Rental Period" && (// Do not show rental start and end dates for purchase variant types
                    values === null || values === void 0 ? void 0 : values.find(function(value) {
                        return (value === null || value === void 0 ? void 0 : value.name) !== "Purchase";
                    })) && rentalStartDateFormat && rentalEndDateFormat ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        w: [
                            "6rem",
                            "auto"
                        ],
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                as: "p",
                                children: [
                                    attribute.name,
                                    ":",
                                    " ",
                                    values.map(function(value) {
                                        return value === null || value === void 0 ? void 0 : value.name;
                                    }).join(", ")
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                mt: [
                                    "1rem",
                                    "0"
                                ],
                                display: [
                                    "block",
                                    "flex"
                                ],
                                children: [
                                    "Start:",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                        ml: [
                                            "0",
                                            "0.3rem"
                                        ],
                                        children: [
                                            " ",
                                            rentalStartDateFormat
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                mt: [
                                    "1rem",
                                    "0"
                                ],
                                display: [
                                    "block",
                                    "flex"
                                ],
                                children: [
                                    "End: ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                        ml: [
                                            "0",
                                            "0.3rem"
                                        ],
                                        children: [
                                            " ",
                                            rentalEndDateFormat
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, attribute.id) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        children: [
                            attribute.name,
                            ":",
                            " ",
                            values.map(function(value) {
                                return value === null || value === void 0 ? void 0 : value.name;
                            }).join(", ")
                        ]
                    }, attribute.id);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                className: "quantity-cell",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    children: line.quantity
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                colSpan: 2,
                style: {
                    textAlign: "right"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(containers/* TaxedMoney */.a, {
                    taxedMoney: line.totalPrice
                })
            })
        ]
    });
};
/* harmony default export */ var CartTable_ProductRow = (ProductRow);

// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var constants = __webpack_require__(71467);
;// CONCATENATED MODULE: ./src/components/legacy/CartTable/styles.ts

function CartTable_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    td:last-child,\n    th:last-child {\n      text-align: right;\n    }\n  }\n\n  .row--processing td {\n    position: relative;\n\n    &::after {\n      background-color: rgba(",
        ', 0.65);\n      position: absolute;\n      content: "";\n      width: 100%;\n      height: 100%;\n      left: 0;\n      top: 0;\n    }\n  }\n\n  .cost {\n    color: ',
        ";\n    font-weight: ",
        ";\n    text-transform: uppercase;\n  }\n\n  .quantity-header {\n    text-align: center;\n    padding: 0;\n  }\n\n  .quantity-cell {\n    padding: 0;\n    text-align: center;\n\n    div {\n      align-items: center;\n      display: flex;\n      justify-content: space-around;\n\n      @media (max-width: ",
        ") {\n        flex-direction: column-reverse;\n      }\n\n      &.disabled {\n        opacity: 0.8;\n\n        &:hover svg {\n          cursor: default;\n        }\n      }\n    }\n\n    & > div {\n      padding: ",
        "rem;\n    }\n  }\n\n  svg:hover {\n    cursor: pointer;\n  }\n\n  .thumbnail {\n    display: inline-block;\n    height: 100px;\n    width: 70px;\n    margin-right: 10px;\n    position: relative;\n  }\n\n  .product-row {\n    display: flex;\n    align-items: center;\n  }\n\n  .checkout-action {\n    text-align: right;\n    margin: 0 ",
        "rem ",
        "rem 0;\n\n    @media (max-width: ",
        ") {\n      text-align: center;\n    }\n  }\n\n  .empty {\n    text-align: center;\n    padding: ",
        "rem 0;\n\n    h4 {\n      font-weight: ",
        ";\n      text-transform: uppercase;\n      margin-bottom: ",
        "rem;\n    }\n\n    p {\n      color: ",
        ";\n    }\n\n    &__action {\n      text-align: center;\n      margin-top: ",
        "rem;\n    }\n  }\n"
    ]);
    CartTable_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CartTable = emotion_styled_browser_esm/* default.table */.Z.table(CartTable_styles_templateObject(), constants/* mediumScreen */.M7, constants/* white */.ix, constants/* baseFontColor */.Bq, constants/* boldFontWeight */.NW, constants/* smallScreen */.xC, constants/* spacer */.OF / 2, constants/* spacer */.OF * 2, constants/* spacer */.OF * 3, constants/* smallScreen */.xC, constants/* spacer */.OF * 5, constants/* boldFontWeight */.NW, constants/* spacer */.OF, constants/* gray */.MA, constants/* spacer */.OF);
/* harmony default export */ var CartTable_styles = ({
    CartTable: CartTable
});

;// CONCATENATED MODULE: ./src/components/legacy/CartTable/Table.tsx












var Table = function(_param) {
    var subtotal = _param.subtotal, deliveryCost = _param.deliveryCost, borrowerFee = _param.borrowerFee, totalCost = _param.totalCost, discount = _param.discount, discountName = _param.discountName, lines = _param.lines, rentalPeriod = _param.rentalPeriod, reservations = _param.reservations, _displayNewHeaders = _param.displayNewHeaders, displayNewHeaders = _displayNewHeaders === void 0 ? false : _displayNewHeaders, rowProps = (0,_object_without_properties/* default */.Z)(_param, [
        "subtotal",
        "deliveryCost",
        "borrowerFee",
        "totalCost",
        "discount",
        "discountName",
        "lines",
        "rentalPeriod",
        "reservations",
        "displayNewHeaders"
    ]);
    var intl = (0,intl_shim/* useIntl */.YB)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
        query: {
            minWidth: variables/* smallScreen */.xC
        },
        children: function(mediumScreen) {
            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CartTable_styles.CartTable, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: displayNewHeaders ? "Item" : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.products */.i4.products))
                                }),
                                mediumScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: displayNewHeaders ? "Per Unit" : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.price */.i4.price))
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.variant */.i4.variant))
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    className: "quantity-header",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.qty */.i4.qty))
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    colSpan: 1,
                                    style: {
                                        textAlign: "right"
                                    },
                                    children: displayNewHeaders ? "Total (incl GST)" : mediumScreen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.totalPrice */.i4.totalPrice)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.price */.i4.price))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: lines.map(function(line) {
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_ProductRow, (0,_object_spread/* default */.Z)({
                                reservation: reservations === null || reservations === void 0 ? void 0 : reservations[0],
                                line: line,
                                mediumScreen: mediumScreen
                            }, rowProps), line.id);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tfoot", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_CostRow, {
                                mediumScreen: mediumScreen,
                                heading: intl.formatMessage(src_intl/* commonMessages.variant */.i4.variant),
                                cost: subtotal
                            }),
                            discount && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_CostRow, {
                                mediumScreen: mediumScreen,
                                heading: intl.formatMessage({
                                    defaultMessage: "Discount: {discountName}"
                                }, {
                                    discountName: discountName
                                }),
                                cost: discount
                            }),
                            deliveryCost && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_CostRow, {
                                mediumScreen: mediumScreen,
                                heading: intl.formatMessage({
                                    defaultMessage: "Delivery Cost"
                                }),
                                cost: deliveryCost
                            }),
                            borrowerFee && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_CostRow, {
                                mediumScreen: mediumScreen,
                                heading: intl.formatMessage((0,misc/* isPurchase */.m4)(rentalPeriod) ? src_intl/* commonMessages.purchaserFee */.i4.purchaserFee : src_intl/* commonMessages.borrowerfee */.i4.borrowerfee),
                                cost: borrowerFee
                            }),
                            totalCost && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartTable_CostRow, {
                                mediumScreen: mediumScreen,
                                heading: intl.formatMessage({
                                    defaultMessage: "Total Cost"
                                }),
                                cost: totalCost
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var CartTable_Table = (Table);

;// CONCATENATED MODULE: ./src/components/legacy/CartTable/index.ts


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants.ts
var src_constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/legacy/Breadcrumbs/styles.ts

function Breadcrumbs_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Breadcrumbs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border-style: none;\n  transition: 0.3s;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin-top: 1rem;\n  &:not(:last-of-type) {\n    &:after {\n      content: url("../../../../images/breadcrumbs-arrow.svg");\n      display: inline-block;\n      margin: 0 ',
        "rem;\n    }\n  }\n\n  a {\n    color: ",
        ";\n    vertical-align: middle;\n    transition: 0.3s;\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n    }\n  }\n\n  &.active {\n    a {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var crumbStyle = "\n  display: inline-flex;\n  flex-wrap: wrap;\n";
var CrumbsList = emotion_styled_browser_esm/* default.ul */.Z.ul(Breadcrumbs_styles_templateObject(), crumbStyle);
var CrumbsDiv = emotion_styled_browser_esm/* default.div */.Z.div(styles_templateObject1(), crumbStyle);
var BackLink = emotion_styled_browser_esm/* default.button */.Z.button(styles_templateObject2(), function(props) {
    return props.theme.colors.legacy.grayMedium;
}, function(props) {
    return props.theme.colors.primary.base;
});
var Li = emotion_styled_browser_esm/* default.li */.Z.li(styles_templateObject3(), function(props) {
    return parseInt(props.theme.spacing.spacer, 10) / 2;
}, function(props) {
    return props.theme.colors.legacy.grayMedium;
}, function(props) {
    return props.theme.colors.primary.base;
}, function(props) {
    return props.theme.colors.legacy.grayMedium;
}, function(props) {
    return props.theme.colors.legacy.grayDark;
});
/* harmony default export */ var Breadcrumbs_styles = ({
    CrumbsList: CrumbsList,
    CrumbsDiv: CrumbsDiv,
    Li: Li,
    BackLink: BackLink
});

;// CONCATENATED MODULE: ./src/components/legacy/Breadcrumbs/index.tsx













var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, router = param.router;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
        query: {
            minWidth: variables/* smallScreen */.xC
        },
        children: function(matches) {
            return matches ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Breadcrumbs_styles.CrumbsList, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs_styles.Li, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: paths/* paths.home */.H.home,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, (0,_object_spread/* default */.Z)({}, src_intl/* commonMessages.home */.i4.home))
                        })
                    }),
                    breadcrumbs.map(function(breadcrumb, index) {
                        var isDresses = breadcrumb.value === "Dresses";
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs_styles.Li, {
                            className: classnames_default()({
                                active: index === breadcrumbs.length - 1
                            }),
                            children: isDresses ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "/dresses",
                                children: "Dresses"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                prefetch: false,
                                href: breadcrumb.link,
                                scroll: false,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    children: breadcrumb.value
                                })
                            })
                        }, "".concat(breadcrumb.value, "-").concat(index));
                    })
                ]
            }) : !src_constants/* ssrMode */.$m && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs_styles.CrumbsDiv, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs_styles.BackLink, {
                    onClick: function() {
                        return router.back();
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_shim/* FormattedMessage */._H, {
                        defaultMessage: "Back"
                    })
                })
            });
        }
    });
};
/* harmony default export */ var legacy_Breadcrumbs = ((0,next_router.withRouter)(Breadcrumbs));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(37496);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(11463);
;// CONCATENATED MODULE: ./src/components/atoms/MobileNavSearch/MobileNavSearchOverlayBG.tsx




var MobileNavSearchOverlayBG = function(param) {
    var children = param.children, closeSearchHandler = param.closeSearchHandler;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        height: "100vh",
        width: "100vw",
        maxW: "100%",
        zIndex: 1010,
        bgColor: theme.colors.overlay,
        position: "absolute",
        top: {
            base: constants/* navMenuSearchMobileHeight */.Td,
            xl: constants/* navMenuSearchXLHeight */.xg
        },
        onClick: closeSearchHandler,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/MobileNavSearch/MobileNavSearchOverlayFG.tsx


var MobileNavSearchOverlayFG = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        width: "100%",
        zIndex: 1020,
        bgColor: "tertiary",
        p: [
            "0.7rem",
            null,
            null,
            "1.5rem"
        ],
        position: "absolute",
        children: children
    });
};

// EXTERNAL MODULE: ./src/components/legacy/MenuProvider/context.ts
var context = __webpack_require__(14077);
;// CONCATENATED MODULE: ./src/components/legacy/MainMenu/MainMenu.tsx














var MainMenu = function(param) {
    var login = param.login, handleSignOut = param.handleSignOut, loading = param.loading;
    var router = (0,next_router.useRouter)();
    var mainMenu = (0,react.useContext)(context/* MenuContext */.p).mainMenu;
    var user = (0,lib.useAuth)().user;
    var overlay = react.useContext(OverlayContext);
    var isSearchInputOpen = overlay.type === OverlayType.search;
    var ref = (0,react.useState)(true), isPinned = ref[0], setIsPinned = ref[1];
    var ref1 = (0,react.useState)(null), activeMenu = ref1[0], setActiveMenu = ref1[1];
    if (!mainMenu) {
        return null;
    }
    var resetActiveMenu = function() {
        setActiveMenu(null);
    };
    (0,react.useEffect)(function() {
        var handleScrollChange = function() {
            if (router.pathname !== "/") {
                setIsPinned(true);
                return;
            }
            if (window.scrollY === 0) {
                setIsPinned(true);
            } else {
                setIsPinned(false);
            }
        };
        window.addEventListener("scroll", handleScrollChange);
        return function() {
            window.removeEventListener("scroll", handleScrollChange);
        };
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        id: "header",
        position: "sticky",
        zIndex: 1000,
        top: 0,
        display: "flex",
        alignItems: "center",
        flex: "none",
        flexDirection: "column",
        width: {
            xl: "100%"
        },
        color: "black",
        backgroundColor: "primary",
        onMouseLeave: resetActiveMenu,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                position: "relative",
                width: "100%",
                top: {
                    base: 0,
                    xl: constants/* navMenuXLHeight */.yf
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* ScaleFade */.MT, {
                        in: isSearchInputOpen,
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavSearchOverlayFG, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MobileNavSearch, {
                                hideNav: overlay.hide
                            })
                        })
                    }),
                    isSearchInputOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavSearchOverlayBG, {
                        closeSearchHandler: overlay.hide
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        position: "relative",
                        paddingX: {
                            base: "20px",
                            xl: "1.75rem"
                        },
                        justifyContent: "space-between",
                        paddingTop: {
                            base: "0.938rem",
                            xl: 0
                        },
                        paddingBottom: {
                            base: "0.6rem",
                            xl: 0
                        },
                        width: "100%",
                        minHeight: {
                            xl: constants/* navMenuXLHeight */.yf
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MainMenuLeft, {
                                loading: loading,
                                menu: mainMenu,
                                login: login,
                                user: user
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                display: "flex",
                                justifyContent: "center",
                                flex: {
                                    base: "1 1 0px",
                                    xl: "auto"
                                },
                                marginBottom: {
                                    base: "auto",
                                    xl: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                                        query: {
                                            maxWidth: constants/* xLargeScreen */.hZ - 1
                                        },
                                        defaultMatches: src_constants/* ssrMode */.$m,
                                        render: function() {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.LogoLink, {});
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                                        query: {
                                            minWidth: constants/* xLargeScreen */.hZ
                                        },
                                        defaultMatches: src_constants/* ssrMode */.$m,
                                        render: function() {
                                            return isPinned ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* MainMenuExpandableSection */.mo, {
                                                mainMenu: mainMenu
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.LogoLink, {});
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MainMenuRight, {
                                menu: mainMenu,
                                loading: loading,
                                user: user,
                                handleSignOut: handleSignOut,
                                login: login,
                                resetActiveMenu: resetActiveMenu
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                        query: {
                            minWidth: constants/* xLargeScreen */.hZ
                        },
                        defaultMatches: src_constants/* ssrMode */.$m,
                        render: function() {
                            return !isPinned && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                w: "full",
                                position: "absolute",
                                bgColor: "white",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: {
                                        base: "auto",
                                        xl: 0
                                    },
                                    borderTop: "0.5px solid gray",
                                    borderBottom: "0.5px solid gray",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* MainMenuExpandableSection */.mo, {
                                        mainMenu: mainMenu,
                                        lower: true
                                    })
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Collapse */.UO, {
                        animateOpacity: true,
                        in: isPinned && !!activeMenu,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            w: "full",
                            position: "absolute",
                            bgColor: "secondary",
                            p: "2.5rem 6rem",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* MainMenuExpandableSection */.mo, {
                                mainMenu: mainMenu
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/legacy/MainMenu/index.ts


;// CONCATENATED MODULE: ./src/components/legacy/NavLink/index.tsx








var NavLink = function(_param) {
    var item = _param.item, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item"
    ]);
    var name = item.name, url = item.url, category = item.category, collection = item.collection, page = item.page, link = item.link;
    var getlink = function(linkUrl) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            passHref: true,
            href: linkUrl,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: name
            }))
        });
    };
    // For external links
    if (url) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: url
        }, props), {
            children: name
        }));
    }
    // For internal links
    if (link) {
        return getlink(link);
    }
    if (category) {
        return getlink((0,react_router/* generatePath */.Gn)(paths/* paths.category */.H.category, {
            slug: category.slug
        }));
    }
    if (collection) {
        return getlink((0,react_router/* generatePath */.Gn)(paths/* paths.collection */.H.collection, {
            slug: collection.slug
        }));
    }
    if (page) {
        return getlink((0,react_router/* generatePath */.Gn)(paths/* paths.page */.H.page, {
            slug: page.slug
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: name
    }));
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/core/config.ts
var config = __webpack_require__(72314);
;// CONCATENATED MODULE: ./src/components/legacy/Meta/context.tsx


var /*#__PURE__*/ ref = react.createContext(config/* META_DEFAULTS */.k);
var Provider = ref.Provider, Consumer = ref.Consumer;

;// CONCATENATED MODULE: ./src/components/legacy/Meta/consumer.tsx





function truncateMetaDescription(metaDescription) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 155;
    if (metaDescription.length > maxLength) {
        // Trim the string to the maximum length and add "..." at the end
        return "".concat(metaDescription.substring(0, maxLength - 3), "...");
    }
    // Return the original string if it's within the limit
    return metaDescription;
}
var consumer_Consumer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Consumer, {
        children: function(param) {
            var title = param.title, description = param.description, image = param.image, type = param.type, url = param.url, canonicalUrl = param.canonicalUrl, language = param.language, marketplaces = param.marketplaces;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                                children: title
                            }),
                            canonicalUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                                rel: "canonical",
                                href: canonicalUrl
                            }),
                            language && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "locale",
                                content: language
                            }),
                            marketplaces && marketplaces.length > 0 && marketplaces.map(function(marketplace, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                                    rel: "alternate",
                                    hrefLang: marketplace.language,
                                    href: marketplace.siteUrl
                                }, index);
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "description",
                                content: truncateMetaDescription(description)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:description",
                                content: truncateMetaDescription(description)
                            }, "og:description"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:url",
                                content: url || src_constants/* ssrMode */.$m ? __webpack_require__.g.location.href : window.location.href
                            }, "og:url"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:title",
                                content: title
                            }, "og:title"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:type",
                                content: type
                            }, "og:type"),
                            !!image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:image",
                                content: image
                            }, "og:image")
                        ]
                    }),
                    children
                ]
            });
        }
    });
};
/* harmony default export */ var consumer = (consumer_Consumer);

// EXTERNAL MODULE: ./src/components/legacy/ShopProvider/context.ts
var ShopProvider_context = __webpack_require__(61888);
;// CONCATENATED MODULE: ./src/components/legacy/Meta/MetaWrapper.tsx








var removeEmpty = function(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function(prop) {
        if (obj[prop] && obj[prop] !== "") {
            newObj[prop] = obj[prop];
        }
    });
    return newObj;
};
var MetaWrapper = function(param) {
    var children = param.children, meta = param.meta;
    var shopData = react.useContext(ShopProvider_context/* ShopContext */.I);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Provider, {
        value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config/* META_DEFAULTS */.k, removeEmpty(meta)), {
            language: shopData.language
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(consumer, {
            children: children
        })
    });
};
/* harmony default export */ var Meta_MetaWrapper = (MetaWrapper);

;// CONCATENATED MODULE: ./src/components/legacy/Meta/index.ts



// EXTERNAL MODULE: ./src/components/organisms/index.ts + 9 modules
var organisms = __webpack_require__(14254);
;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/Cart/Cart.tsx






var Cart = function(param) {
    var overlay = param.overlay;
    var ref;
    var push = (0,next_router.useRouter)().push;
    var user = (0,lib.useAuth)().user;
    var checkout = (0,lib.useCheckout)().checkout;
    var ref1 = (0,lib.useCart)(), items = ref1.items, updateItem = ref1.updateItem, removeItem = ref1.removeItem, subtotalPrice = ref1.subtotalPrice, shippingPrice = ref1.shippingPrice, discount = ref1.discount, totalPrice = ref1.totalPrice, borrowerFee = ref1.borrowerFee;
    var shippingTaxedPrice = (checkout === null || checkout === void 0 ? void 0 : (ref = checkout.shippingMethod) === null || ref === void 0 ? void 0 : ref.id) && shippingPrice ? {
        gross: shippingPrice,
        net: shippingPrice
    } : null;
    var promoTaxedPrice = discount && {
        gross: discount,
        net: discount
    };
    var borrowerFeeValue = borrowerFee === null || borrowerFee === void 0 ? void 0 : borrowerFee.amount;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* CartSidebar */.zY, {
        show: true,
        updateItem: updateItem,
        removeItem: removeItem,
        hide: overlay.hide,
        items: items,
        subtotalPrice: subtotalPrice,
        shippingTaxedPrice: shippingTaxedPrice,
        promoTaxedPrice: promoTaxedPrice,
        totalPrice: totalPrice,
        continueShopping: function() {
            overlay.hide();
        },
        goToCart: function() {
            push(paths/* paths.checkout */.H.checkout);
            overlay.hide();
        },
        proceedToCheckout: function() {
            push(user ? paths/* paths.checkout */.H.checkout : paths/* paths.login */.H.login);
            overlay.hide();
        },
        borrowerFee: borrowerFeeValue
    });
};
/* harmony default export */ var Cart_Cart = (Cart);

;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/Cart/index.ts


;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/Modal/index.tsx



var Modal = function(param) {
    var overlay = param.overlay, testingContext = param.testingContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy_Overlay_Overlay, {
        testingContext: testingContext,
        context: overlay,
        children: overlay.context.content
    });
};
/* harmony default export */ var OverlayManager_Modal = (Modal);

;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/Notification.tsx



var NotificationOverlay = function(param) {
    var _overlay = param.overlay, hide = _overlay.hide, context = _overlay.context;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy_Message, {
        title: context.title,
        status: context.status,
        onClose: hide,
        children: context.content
    });
};
/* harmony default export */ var Notification = (NotificationOverlay);

;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/Manager.tsx








var renderMobileNav = function(overlay, login, handleSignOut) {
    switch(overlay.type){
        case OverlayType.mobileAccount:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MobileNav */.zM, {
                showAccount: true,
                login: login,
                signOut: handleSignOut,
                hideNav: overlay.hide
            });
        case OverlayType.mobileMainMenu:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MobileNav */.zM, {
                showMainMenu: true,
                login: login,
                signOut: handleSignOut,
                hideNav: overlay.hide,
                menuItems: overlay.context.data
            });
        default:
            return null;
    }
};
var OverlayManager = function(param) {
    var login = param.login, handleSignOut = param.handleSignOut;
    var overlay = react.useContext(OverlayContext);
    if (overlay.type === OverlayType.mobileAccount || overlay.type === OverlayType.mobileMainMenu || overlay.type === null) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Fade */.pT, {
            in: !!overlay.type,
            unmountOnExit: true,
            style: {
                zIndex: 1001
            },
            children: renderMobileNav(overlay, login, handleSignOut)
        });
    }
    switch(overlay.type){
        case OverlayType.modal:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverlayManager_Modal, {
                testingContext: "modal",
                overlay: overlay
            });
        case OverlayType.message:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification, {
                overlay: overlay
            });
        case OverlayType.cart:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cart_Cart, {
                overlay: overlay
            });
        case OverlayType.mainMenuNav:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy_Overlay_Overlay, {
                testingContext: "mainMenuOverlay",
                context: overlay
            });
        default:
            return null;
    }
};
/* harmony default export */ var Manager = (OverlayManager);

;// CONCATENATED MODULE: ./src/components/legacy/OverlayManager/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/legacy/Overlay/styles.ts

function Overlay_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: rgba(199, 207, 207, 0.8);\n  height: 100%;\n  position: fixed;\n  top: 0;\n  transition: 300ms;\n  width: 100%;\n  z-index: 10000;\n\n  .search {\n    .overlay__right {\n      background-color: transparent;\n      height: auto;\n    }\n  }\n\n  .no-background {\n    background-color: transparent;\n  }\n\n  .left {\n    position: fixed;\n    min-height: 100%;\n    background-color: ",
        ";\n    animation: sidenavLeftOpen 0.3s;\n  }\n\n  .right {\n    position: fixed;\n    background-color: ",
        ";\n    right: 0;\n    top: 0;\n    height: 100%;\n    animation: sidenavRightOpen 0.3s;\n  }\n\n  .header {\n    align-items: center;\n    border-bottom: 1px solid ",
        ";\n    display: flex;\n    flex: 1;\n    font-weight: ",
        ";\n    height: 3.6rem;\n    justify-content: space-between;\n    text-transform: uppercase;\n\n    header-text {\n      margin: 0 ",
        "rem;\n      text-align: center;\n\n      header-items {\n        color: ",
        ";\n      }\n    }\n\n    header__close-icon {\n      cursor: pointer;\n      margin: 0 ",
        "rem;\n\n      &:hover,\n      &:focus {\n        svg {\n          * {\n            fill: ",
        ";\n          }\n        }\n      }\n      div {\n        display: flex;\n      }\n    }\n\n    header__cart-icon {\n      margin: 0 ",
        "rem;\n\n      div {\n        display: flex;\n        svg {\n          * {\n            fill: ",
        ";\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Overlay_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Overlay = emotion_styled_browser_esm/* default.div */.Z.div(Overlay_styles_templateObject(), constants/* white */.ix, constants/* white */.ix, constants/* grayLight */.e7, constants/* boldFontWeight */.NW, constants/* spacer */.OF, constants/* gray */.MA, constants/* spacer */.OF, constants/* accentBlue */.H5, constants/* spacer */.OF, constants/* accentBlue */.H5);
/* harmony default export */ var Overlay_styles = ({
    Overlay: Overlay
});

;// CONCATENATED MODULE: ./src/components/legacy/Overlay/Overlay.tsx





var Overlay_Overlay = function(param) {
    var children = param.children, className = param.className, _context = param.context, type = _context.type, theme = _context.theme, hide = _context.hide, testingContext = param.testingContext;
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay_styles.Overlay, {
        className: classnames_default()("overlay", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(type), !!type), (0,_define_property/* default */.Z)(_obj, className, !!className), _obj)),
        "data-test": testingContext,
        onClick: hide,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "".concat(theme),
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: children
        })
    });
};
/* harmony default export */ var legacy_Overlay_Overlay = (Overlay_Overlay);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
;// CONCATENATED MODULE: ./src/components/legacy/Overlay/provider.tsx
/* eslint-disable react/no-unused-state */ 





var provider_Provider = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Provider, _Component);
    var _super = (0,_create_super/* default */.Z)(Provider);
    function Provider(props) {
        (0,_class_call_check/* default */.Z)(this, Provider);
        var _this;
        _this = _super.call(this, props);
        _this.notificationCloseDelay = 2500;
        _this.show = function(type, theme, context) {
            _this.setState({
                type: type,
                theme: theme,
                context: context
            });
            document.body.style.overflow = type !== OverlayType.message ? "hidden" : "";
            if (type === OverlayType.message) {
                setTimeout(_this.hide, _this.notificationCloseDelay);
            }
        };
        _this.hide = function() {
            _this.setState({
                type: null
            });
            document.body.style.overflow = "";
        };
        _this.toggle = function(type, theme, context) {
            if (_this.state.type !== type) {
                _this.show(type, theme, context);
            } else {
                _this.hide();
            }
        };
        _this.state = {
            context: null,
            hide: _this.hide,
            show: _this.show,
            toggle: _this.toggle,
            theme: null,
            type: null
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.pathname !== prevProps.pathname && this.state.type !== OverlayType.message) {
            this.hide();
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverlayContext.Provider, {
            value: this.state,
            children: this.props.children
        });
    };
    return Provider;
}(react.Component);
/* harmony default export */ var provider = (provider_Provider);

;// CONCATENATED MODULE: ./src/components/legacy/Overlay/context.tsx

var OverlayType;
(function(OverlayType) {
    OverlayType["cart"] = "cart";
    OverlayType["checkout"] = "checkout";
    OverlayType["login"] = "login";
    OverlayType["message"] = "message";
    OverlayType["sideNav"] = "side-nav";
    OverlayType["password"] = "password";
    OverlayType["search"] = "search";
    OverlayType["mainMenuNav"] = "main-menu-nav";
    OverlayType["modal"] = "modal";
    OverlayType["register"] = "register";
    OverlayType["mobileAccount"] = "mobile-account";
    OverlayType["mobileMainMenu"] = "mobile-main-menu";
})(OverlayType || (OverlayType = {}));
var OverlayTheme;
(function(OverlayTheme) {
    OverlayTheme["left"] = "left";
    OverlayTheme["right"] = "right";
    OverlayTheme["modal"] = "modal";
})(OverlayTheme || (OverlayTheme = {}));
var OverlayContext = /*#__PURE__*/ react.createContext({
    context: null,
    hide: function() {},
    show: function(type) {},
    toggle: function(type) {},
    theme: null,
    type: null
});
OverlayContext.displayName = "OverlayContext";

;// CONCATENATED MODULE: ./src/components/legacy/Overlay/index.tsx




// EXTERNAL MODULE: ./node_modules/use-query-params/esm/index.js + 15 modules
var esm = __webpack_require__(97947);
;// CONCATENATED MODULE: ./src/components/legacy/NextQueryParamProvider.tsx








var NextQueryParamProviderComponent = function(props) {
    var children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var match = router.asPath.match(/[^?]+/);
    var pathname = match ? match[0] : router.asPath;
    var location = (0,react.useMemo)(function() {
        return src_constants/* ssrMode */.$m ? {
            search: router.asPath.replace(RegExp("[^?]+", "u"), "")
        } : window.location;
    }, [
        router.asPath
    ]);
    var history = (0,react.useMemo)(function() {
        return {
            push: function(param) {
                var search = param.search;
                return router.push({
                    pathname: router.pathname,
                    query: router.query
                }, {
                    search: search,
                    pathname: pathname
                }, {
                    shallow: true
                });
            },
            replace: function(param) {
                var search = param.search;
                router.replace({
                    pathname: router.pathname,
                    query: router.query
                }, {
                    search: search,
                    pathname: pathname
                }, {
                    shallow: true
                });
            },
            location: location
        };
    }, [
        pathname,
        location,
        router
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm/* QueryParamProvider */.Fz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        history: history,
        location: location,
        children: children
    }));
};
var NextQueryParamProvider = /*#__PURE__*/ (0,react.memo)(NextQueryParamProviderComponent);

;// CONCATENATED MODULE: ./src/components/legacy/index.ts
// TODO: Deprecate or move these components to a differnt component folder
// Do not add more exports to this file

















/***/ }),

/***/ 14254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HY": function() { return /* binding */ AddToCartSection; },
  "Gu": function() { return /* binding */ AddToCartSectionDesignB; },
  "kS": function() { return /* binding */ AddressForm; },
  "kU": function() { return /* binding */ AddressFormModal; },
  "Q1": function() { return /* binding */ AddressGrid; },
  "_U": function() { return /* binding */ AddressGridSelector; },
  "I": function() { return /* binding */ AsSeenIn; },
  "lr": function() { return /* binding */ Carousel; },
  "oZ": function() { return /* binding */ CartRow; },
  "zY": function() { return /* binding */ CartSidebar; },
  "VD": function() { return /* binding */ CartSummary; },
  "pS": function() { return /* binding */ CheckoutAddress; },
  "iQ": function() { return /* binding */ CheckoutPayment; },
  "ep": function() { return /* binding */ CheckoutReview; },
  "Uu": function() { return /* binding */ CheckoutShipping; },
  "x": function() { return /* binding */ CircularPartners; },
  "Uz": function() { return /* binding */ CollectionGrid; },
  "mv": function() { return /* binding */ ContactDetails; },
  "Mt": function() { return /* binding */ DatePicker; },
  "jN": function() { return /* binding */ DiscountForm; },
  "cE": function() { return /* binding */ DummyPaymentGateway; },
  "N0": function() { return /* binding */ FeaturedDesigners; },
  "zA": function() { return /* binding */ FilterSidebar; },
  "$_": function() { return /* reexport */ Footer; },
  "$x": function() { return /* binding */ InputDatePicker; },
  "zM": function() { return /* binding */ MobileNav; },
  "iC": function() { return /* binding */ MobileNavMainMenu; },
  "u_": function() { return /* binding */ Modal; },
  "aV": function() { return /* binding */ Overlay; },
  "Li": function() { return /* binding */ PaymentGatewaysList; },
  "YP": function() { return /* binding */ ProductGallery; },
  "cm": function() { return /* reexport */ ProductList; },
  "EX": function() { return /* binding */ ProductListHeader; },
  "lS": function() { return /* binding */ SeamlessLending; },
  "XK": function() { return /* binding */ StripePaymentGateway; },
  "i$": function() { return /* binding */ ThankYou; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js + 1 modules
var chakra_ui_spinner_esm = __webpack_require__(89238);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(37496);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/intl.ts
var intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/images/arrow-right.svg
/* harmony default export */ var arrow_right = ({"src":"/_next/static/media/arrow-right.39da3779.svg","height":22,"width":26});
;// CONCATENATED MODULE: ./src/components/organisms/KlaviyoSubscriber/index.tsx









var handleAddToKlavyoList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(email, handleSuccessCallback, handleErrorCallback) {
        var url, options, response, ref, ref1, errorData, errorMessage, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    url = "https://a.klaviyo.com/client/subscriptions/?company_id=".concat(constants/* klaviyoPublicKey */.S5);
                    options = {
                        method: "POST",
                        headers: {
                            revision: "2023-06-15",
                            "content-type": "application/json"
                        },
                        body: JSON.stringify({
                            data: {
                                type: "subscription",
                                attributes: {
                                    list_id: constants/* klaviyoSubscribeListId */.J_,
                                    custom_source: "Homepage footer signup form",
                                    email: email
                                }
                            }
                        })
                    };
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        2
                    ];
                    handleSuccessCallback();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    errorData = _state.sent();
                    errorMessage = ((ref = errorData.errors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.detail) || "An error occurred";
                    handleErrorCallback(errorMessage);
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    handleErrorCallback("An error occurred while subscribing. Please try again.");
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleAddToKlavyoList(email, handleSuccessCallback, handleErrorCallback) {
        return _ref.apply(this, arguments);
    };
}();
var KlaviyoSubscriber = function() {
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(""), successMessage = ref3[0], setSuccessMessage = ref3[1];
    var inputRef = (0,react.useRef)(null);
    var handleSubscribe = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, handleSuccessCallback, handleErrorCallback, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        handleSuccessCallback = function() {
                            setSuccessMessage(intl/* commonMessages.thankYouSubscribe.defaultMessage */.i4.thankYouSubscribe.defaultMessage);
                            setEmail("");
                        };
                        handleErrorCallback = function(errorMessage) {
                            setError(errorMessage);
                        };
                        setLoading(true);
                        setError("");
                        if (!(inputRef === null || inputRef === void 0 ? void 0 : (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.checkValidity())) {
                            setError("Invalid email address");
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!email) {
                            setError("Email is required");
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            handleAddToKlavyoList(email, handleSuccessCallback, handleErrorCallback)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setError("An error occurred while subscribing. Please try again.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubscribe(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyUp = function(e) {
        if (e.key === "Enter") {
            handleSubscribe(e);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "tertiary",
        w: "full",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    fontSize: "1.4rem",
                    lineHeight: "1.5rem",
                    children: "STAY IN THE KNOW ON THE LATEST STYLES"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    display: "flex",
                    mx: "auto",
                    mt: "1rem",
                    children: !successMessage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        as: "form",
                        borderBottom: "1px dashed white",
                        display: "flex",
                        justifyContent: "space-between",
                        py: "0.5rem",
                        fontSize: "1.2rem",
                        mx: loading ? "auto" : "none",
                        onSubmit: handleSubscribe,
                        children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_spinner_esm/* Spinner */.$, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    ref: inputRef,
                                    as: "input",
                                    type: "email",
                                    placeholder: intl/* commonMessages.enterEmail.defaultMessage */.i4.enterEmail.defaultMessage,
                                    bgColor: "tertiary",
                                    color: "white",
                                    outline: "none",
                                    _placeholder: {
                                        color: "white"
                                    },
                                    onKeyUp: handleKeyUp,
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    },
                                    value: email,
                                    required: true
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "button",
                                    pl: "1rem",
                                    display: "inline",
                                    type: "submit",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                                        src: arrow_right.src
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* ScaleFade */.MT, {
                        initialScale: 0.6,
                        in: true,
                        children: successMessage
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    textAlign: "left",
                    my: "0.5rem",
                    color: "red",
                    children: error
                })
            ]
        })
    });
};
/* harmony default export */ var organisms_KlaviyoSubscriber = (KlaviyoSubscriber);

// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./src/components/legacy/MenuProvider/context.ts
var context = __webpack_require__(14077);
// EXTERNAL MODULE: ./src/images/the_volte_logo_black.svg
var the_volte_logo_black = __webpack_require__(6643);
;// CONCATENATED MODULE: ./src/components/organisms/Footer/index.tsx










var Footer = function() {
    var ref;
    var ref1 = (0,react.useContext)(context/* MenuContext */.p), footer = ref1.footer, siteSetting = ref1.siteSetting;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "tertiary",
        color: "white",
        padding: [
            "4rem 1rem 1rem 1rem",
            null,
            null,
            "4rem 3rem"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
            gap: 5,
            direction: [
                "column",
                "column",
                null,
                "row"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Grid */.rj, {
                    w: "full",
                    templateColumns: {
                        base: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(5, 1fr)"
                    },
                    gap: 6,
                    children: footer === null || footer === void 0 ? void 0 : (ref = footer.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        var ref;
                        if (!item) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* GridItem */.P4, {
                            w: "100%",
                            pb: "1rem",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    fontWeight: "600",
                                    mb: "1rem",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    children: item === null || item === void 0 ? void 0 : (ref = item.children) === null || ref === void 0 ? void 0 : ref.map(function(subItem) {
                                        if (!subItem) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                            my: "0.3rem",
                                            fontSize: [
                                                "0.8rem",
                                                null,
                                                null,
                                                "1rem"
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.CustomLink, {
                                                path: subItem.url || "/",
                                                // rel={subItem?.rel}
                                                target: (subItem === null || subItem === void 0 ? void 0 : subItem.target) || undefined,
                                                passHref: true,
                                                children: subItem.name
                                            })
                                        }, subItem.name);
                                    })
                                })
                            ]
                        }, item.name);
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms_KlaviyoSubscriber, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            display: "flex",
                            alignItems: [
                                null,
                                null,
                                null,
                                "center"
                            ],
                            justifyContent: "start",
                            flexDirection: [
                                "column",
                                null,
                                null,
                                "row"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    mr: "1rem",
                                    children: "FOLLOW\xa0US"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    display: "flex",
                                    mt: [
                                        "1rem",
                                        null,
                                        null,
                                        "0"
                                    ],
                                    children: (siteSetting === null || siteSetting === void 0 ? void 0 : siteSetting.socialMedia) && (siteSetting === null || siteSetting === void 0 ? void 0 : siteSetting.socialMedia.map(function(social) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                            mr: "1rem",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.SocialMediaIcon, {
                                                social: social
                                            }, social.ariaLabel)
                                        }, social.ariaLabel);
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            mt: "3rem",
                            width: [
                                "60%",
                                "50%",
                                "50%",
                                "80%",
                                "90%",
                                "100%"
                            ],
                            marginLeft: [
                                "-10px",
                                "-10px",
                                "-10px",
                                "-15px",
                                "-15px",
                                "-15px"
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                                src: the_volte_logo_black/* default.src */.Z.src
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            mt: "1rem",
                            children: "The Volte ".concat(new Date().getFullYear(), ". All rights reserved.")
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(92684);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js
var index_esm = __webpack_require__(74061);
// EXTERNAL MODULE: ./node_modules/react-window-infinite-loader/dist/index.esm.js
var dist_index_esm = __webpack_require__(65691);
// EXTERNAL MODULE: ./node_modules/react-window-scroller/dist/index.jsx.js
var index_jsx = __webpack_require__(39335);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/atoms/GoToTop/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 540px) {\n    display: block;\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n    width: 40px;\n    height: 40px;\n    background: #fff;\n    border-radius: 50%;\n    box-shadow: rgba(36, 36, 36, 0.15) 0px 20px 30px 0px;\n  }\n  display: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Button = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject());

;// CONCATENATED MODULE: ./src/components/atoms/GoToTop/GoToTopButton.tsx



var GoToTopButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
            onClick: onClick,
            "aria-label": "Go to top button",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: 1.5,
                stroke: "currentColor",
                className: "w-6 h-6",
                alt: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/GoToTop/index.ts


// EXTERNAL MODULE: ./src/components/molecules/index.ts + 68 modules
var molecules = __webpack_require__(27706);
// EXTERNAL MODULE: ./src/hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(83319);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var globalStyles_constants = __webpack_require__(71467);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
;// CONCATENATED MODULE: ./src/components/organisms/ProductList/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-around;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-around;\n    max-width: 75rem;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 75rem;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0 0 1rem;\n  margin: auto;\n\n  ",
        "\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var List = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject()), globalStyles/* minMedia.mediumScreen */.td.mediumScreen(_templateObject1()), globalStyles/* minMedia.xLargeScreen */.td.xLargeScreen(_templateObject2()));

;// CONCATENATED MODULE: ./src/components/organisms/ProductList/ProductList.tsx






















var ProductList = function(param) {
    var products = param.products, _canLoadMore = param.canLoadMore, canLoadMore = _canLoadMore === void 0 ? false : _canLoadMore, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _onLoadMore = param.onLoadMore, onLoadMore = _onLoadMore === void 0 ? function() {
        return null;
    } : _onLoadMore, _showGoToTop = param.showGoToTop, showGoToTop = _showGoToTop === void 0 ? true : _showGoToTop, numberOfProducts = param.numberOfProducts, loadMoreError = param.loadMoreError, infiniteScrollingMode = param.infiniteScrollingMode, deliveryFilter = param.deliveryFilter, hasCollectionSale = param.hasCollectionSale, isWarehouseSaleCollection = param.isWarehouseSaleCollection, warehouseSaleTitle = param.warehouseSaleTitle, _isFetching = param.isFetching, isFetching = _isFetching === void 0 ? false : _isFetching;
    var chunks = function chunks(arr, n) {
        var i;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < arr.length)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        arr.slice(i, i + n)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    i += n;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    };
    var hasWareHouseSale = hasCollectionSale && isWarehouseSaleCollection && warehouseSaleTitle;
    var user = (0,lib.useAuth)().user;
    var ref = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(globalStyles_constants/* breakpoints.xl */.AV.xl, ")")), 1), isDesktop = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(globalStyles_constants/* breakpoints.lg */.AV.lg, ")")), 1), isTablet = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(globalStyles_constants/* breakpoints.md */.AV.md, ")")), 1), isMiniTablet = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(globalStyles_constants/* breakpoints.xs */.AV.xs, ")")), 1), isPhone = ref3[0];
    var productsPerRow = isDesktop ? 4 : isTablet ? 3 : isMiniTablet || isPhone ? 2 : 1; // 1 for fold mobile, 2 for mini tablet or normal phones, 3 for tablet, 4 for desktop
    var itemSize = isDesktop || isTablet || isMiniTablet ? 550 : hasWareHouseSale ? 375 : 355;
    var ref4 = (0,react.useState)(products), modifiedProductsData = ref4[0], setModifiedProductsData = ref4[1];
    var router = (0,next_router.useRouter)();
    var slug = router.asPath;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorageQuiet */.k)("scrollOffset", (0,_define_property/* default */.Z)({}, slug, 0)), 2), scrollState = ref5[0], setScrollState = ref5[1];
    (0,react.useEffect)(function() {
        if (!constants/* ssrMode */.$m) {
            if (user === null || user === void 0 ? void 0 : user.wishlist) {
                setModifiedProductsData((0,arrays/* uniqueByKey */.X)(products.map(function(prod) {
                    var ref, ref1;
                    var inWishlist = user === null || user === void 0 ? void 0 : (ref = user.wishlist) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.some(function(wishlistPro) {
                        return prod.id === wishlistPro.node.productId;
                    });
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prod), {
                        inWishlist: inWishlist
                    });
                }), "slug"));
            } else {
                setModifiedProductsData(products);
            }
        }
    }, [
        user,
        products
    ]);
    var chunkedProducts = (0,_to_consumable_array/* default */.Z)(chunks(modifiedProductsData, productsPerRow));
    var isItemLoaded = function(index) {
        return !canLoadMore || index < chunkedProducts.length;
    };
    var rowCount = chunkedProducts.length + (infiniteScrollingMode && canLoadMore ? 1 : 0);
    var Item = function(param) {
        var index = param.index, style = param.style;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            style: style,
            children: index >= chunkedProducts.length ? loadMoreError ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Center */.M5, {
                padding: 10,
                children: [
                    "Sorry, we couldn't load more items just now",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                        width: "150px",
                        testingContext: "LoadErrorButton",
                        onClick: onLoadMore,
                        children: "Try again"
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Loader, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                children: chunkedProducts[index].map(function(product, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductTile */.vB, {
                        product: product,
                        priority: index === 0 && i === 0,
                        index: index * 2 + i,
                        deliveryFilter: deliveryFilter,
                        hasCollectionSale: hasCollectionSale,
                        isWarehouseSaleCollection: isWarehouseSaleCollection,
                        warehouseSaleTitle: warehouseSaleTitle
                    }, product.id);
                })
            })
        });
    };
    var handleScroll = function(param) {
        var scrollOffset = param.scrollOffset;
        setScrollState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, scrollState), (0,_define_property/* default */.Z)({}, slug, scrollOffset)));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isFetching && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        height: "2000px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_spinner_esm/* Spinner */.$, {
                        color: globalStyles_constants/* accentBlue */.H5,
                        sx: {
                            bottom: 0,
                            height: "50px",
                            left: 0,
                            margin: "auto",
                            position: "fixed",
                            right: "5px",
                            top: "0.875rem",
                            width: "50px"
                        }
                    })
                ]
            }),
            !loading && !isFetching && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* default */.Z, {
                isItemLoaded: isItemLoaded,
                itemCount: numberOfProducts,
                loadMoreItems: infiniteScrollingMode ? onLoadMore : function() {},
                children: function(param) {
                    var onItemsRendered = param.onItemsRendered;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_jsx/* ReactWindowScroller */.s, {
                                children: function(param) {
                                    var ref = param.ref, outerRef = param.outerRef, style = param.style, onScroll = param.onScroll;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FixedSizeList */.t7, {
                                        style: style,
                                        outerRef: outerRef,
                                        itemCount: rowCount,
                                        onItemsRendered: onItemsRendered,
                                        itemSize: itemSize,
                                        ref: ref,
                                        initialScrollOffset: scrollState ? scrollState[slug] : 0,
                                        height: 2000,
                                        onScroll: function(props) {
                                            handleScroll(props.scrollOffset);
                                            onScroll(props);
                                        },
                                        children: Item
                                    });
                                }
                            }),
                            showGoToTop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoToTopButton, {
                                onClick: function() {
                                    window.scrollTo(0, 0);
                                }
                            })
                        ]
                    });
                }
            }),
            !isWarehouseSaleCollection && !loading && !isFetching && !products.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                w: "100%",
                textAlign: "center",
                mt: 4,
                children: "Sorry, no products were found."
            }),
            hasCollectionSale && isWarehouseSaleCollection && !loading && !isFetching && !products.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                w: "100%",
                textAlign: "center",
                mt: 4,
                children: "Sorry, no products were found."
            }),
            infiniteScrollingMode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                height: "2000px"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ProductList/index.ts


;// CONCATENATED MODULE: ./src/components/organisms/index.ts

// export all component to dynamic with then
var AddToCartSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9315), __webpack_require__.e(5283), __webpack_require__.e(9222)]).then(__webpack_require__.bind(__webpack_require__, 3910)).then(function(mod) {
        return mod.AddToCartSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3910)
            ];
        }
    }
});
var AddToCartSectionDesignB = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9315), __webpack_require__.e(5283), __webpack_require__.e(9222)]).then(__webpack_require__.bind(__webpack_require__, 3910)).then(function(mod) {
        return mod.AddToCartSectionDesignB;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3910)
            ];
        }
    }
});
var AddressForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(2175), __webpack_require__.e(319)]).then(__webpack_require__.bind(__webpack_require__, 60319)).then(function(mod) {
        return mod.AddressForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60319)
            ];
        }
    }
});
var AddressFormModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3087).then(__webpack_require__.bind(__webpack_require__, 43087)).then(function(mod) {
        return mod.AddressFormModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43087)
            ];
        }
    }
});
var AddressGrid = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4558).then(__webpack_require__.bind(__webpack_require__, 54558)).then(function(mod) {
        return mod.AddressGrid;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54558)
            ];
        }
    }
});
var AddressGridSelector = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2175), __webpack_require__.e(915)]).then(__webpack_require__.bind(__webpack_require__, 20915)).then(function(mod) {
        return mod.AddressGridSelector;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20915)
            ];
        }
    }
});
var CartRow = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1186).then(__webpack_require__.bind(__webpack_require__, 31186)).then(function(mod) {
        return mod.CartRow;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31186)
            ];
        }
    }
});
var CartSidebar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2474).then(__webpack_require__.bind(__webpack_require__, 72474)).then(function(mod) {
        return mod.CartSidebar;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72474)
            ];
        }
    }
});
var CartSummary = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(1852), __webpack_require__.e(467)]).then(__webpack_require__.bind(__webpack_require__, 90467)).then(function(mod) {
        return mod.CartSummary;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90467)
            ];
        }
    }
});
var CheckoutAddress = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6211).then(__webpack_require__.bind(__webpack_require__, 66211)).then(function(mod) {
        return mod.CheckoutAddress;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66211)
            ];
        }
    }
});
var CheckoutPayment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9659).then(__webpack_require__.bind(__webpack_require__, 9659)).then(function(mod) {
        return mod.CheckoutPayment;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9659)
            ];
        }
    }
});
var CheckoutReview = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6188).then(__webpack_require__.bind(__webpack_require__, 6188)).then(function(mod) {
        return mod.CheckoutReview;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6188)
            ];
        }
    }
});
var CheckoutShipping = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2175), __webpack_require__.e(5677)]).then(__webpack_require__.bind(__webpack_require__, 35677)).then(function(mod) {
        return mod.CheckoutShipping;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35677)
            ];
        }
    }
});
var CollectionGrid = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2101).then(__webpack_require__.bind(__webpack_require__, 32101)).then(function(mod) {
        return mod.CollectionGrid;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32101)
            ];
        }
    }
});
var DiscountForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(2175), __webpack_require__.e(6441)]).then(__webpack_require__.bind(__webpack_require__, 36441)).then(function(mod) {
        return mod.DiscountForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36441)
            ];
        }
    }
});
var DummyPaymentGateway = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2175), __webpack_require__.e(2417)]).then(__webpack_require__.bind(__webpack_require__, 62417)).then(function(mod) {
        return mod.DummyPaymentGateway;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62417)
            ];
        }
    }
});
var FilterSidebar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8437).then(__webpack_require__.bind(__webpack_require__, 68437)).then(function(mod) {
        return mod.FilterSidebar;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68437)
            ];
        }
    }
});
var InputDatePicker = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9315), __webpack_require__.e(286)]).then(__webpack_require__.bind(__webpack_require__, 72730)).then(function(mod) {
        return mod.InputDatePicker;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72730)
            ];
        }
    }
});
var DatePicker = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9315), __webpack_require__.e(8289)]).then(__webpack_require__.bind(__webpack_require__, 23623)).then(function(mod) {
        return mod.DatePicker;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23623)
            ];
        }
    }
});
var MobileNav = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5204).then(__webpack_require__.bind(__webpack_require__, 35204)).then(function(mod) {
        return mod.MobileNav;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35204)
            ];
        }
    }
});
var MobileNavMainMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5925), __webpack_require__.e(4351), __webpack_require__.e(95)]).then(__webpack_require__.bind(__webpack_require__, 50095)).then(function(mod) {
        return mod.MobileNavMainMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50095)
            ];
        }
    }
});
var Modal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6387), __webpack_require__.e(969)]).then(__webpack_require__.bind(__webpack_require__, 969)).then(function(mod) {
        return mod.Modal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(969)
            ];
        }
    }
});
var Overlay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2971).then(__webpack_require__.bind(__webpack_require__, 92971)).then(function(mod) {
        return mod.Overlay;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92971)
            ];
        }
    }
});
var PaymentGatewaysList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9602).then(__webpack_require__.bind(__webpack_require__, 29602)).then(function(mod) {
        return mod.PaymentGatewaysList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29602)
            ];
        }
    }
});
var ProductGallery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5257).then(__webpack_require__.bind(__webpack_require__, 75257)).then(function(mod) {
        return mod.ProductGallery;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75257)
            ];
        }
    }
});
var ProductListHeader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9570).then(__webpack_require__.bind(__webpack_require__, 39570)).then(function(mod) {
        return mod.ProductListHeader;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39570)
            ];
        }
    }
});
var StripePaymentGateway = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6664), __webpack_require__.e(1535)]).then(__webpack_require__.bind(__webpack_require__, 11535)).then(function(mod) {
        return mod.StripePaymentGateway;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11535)
            ];
        }
    }
});
var ThankYou = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1852), __webpack_require__.e(9546)]).then(__webpack_require__.bind(__webpack_require__, 29546)).then(function(mod) {
        return mod.ThankYou;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29546)
            ];
        }
    }
});
var FeaturedDesigners = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(168), __webpack_require__.e(6399)]).then(__webpack_require__.bind(__webpack_require__, 46885)).then(function(mod) {
        return mod.FeaturedDesigners;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46885)
            ];
        }
    }
});
var AsSeenIn = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7716).then(__webpack_require__.bind(__webpack_require__, 47716)).then(function(mod) {
        return mod.AsSeenIn;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47716)
            ];
        }
    }
});
var SeamlessLending = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8002).then(__webpack_require__.bind(__webpack_require__, 48002)).then(function(mod) {
        return mod.SeamlessLending;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48002)
            ];
        }
    }
});
var CircularPartners = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(168), __webpack_require__.e(412)]).then(__webpack_require__.bind(__webpack_require__, 21390)).then(function(mod) {
        return mod.CircularPartners;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21390)
            ];
        }
    }
});
var Carousel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(168), __webpack_require__.e(6385)]).then(__webpack_require__.bind(__webpack_require__, 10203)).then(function(mod) {
        return mod.Carousel;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10203)
            ];
        }
    }
});
var ContactDetails = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(5970), __webpack_require__.e(8845), __webpack_require__.e(8127), __webpack_require__.e(1324)]).then(__webpack_require__.bind(__webpack_require__, 81324)).then(function(mod) {
        return mod.ContactDetails;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81324)
            ];
        }
    }
});




/***/ }),

/***/ 72314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ PROVIDERS; },
/* harmony export */   "k": function() { return /* binding */ META_DEFAULTS; }
/* harmony export */ });
/* harmony import */ var _temp_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* eslint-disable global-require */ 
var PROVIDERS = {
    DUMMY: {
        label: "Dummy"
    },
    STRIPE: {
        label: "Stripe"
    }
};
var META_DEFAULTS = {
    custom: [],
    description: "Dress hire grows your wardrobe with over 20,000 new, chic designer options. We help women get the perfect dress for every event on their calendar.",
    image: "",
    title: "Dress Hire | Australia's Largest Dress Hire Selection",
    type: "website",
    url: !_temp_constants__WEBPACK_IMPORTED_MODULE_0__/* .ssrMode */ .$m ? window.location.origin : ""
};


/***/ }),

/***/ 46635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ useHandlerWhenClickedOutside; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/tsUtils.tsx
var maybe = function(exp, d) {
    try {
        var result = exp();
        return result === undefined ? d : result;
    } catch (e) {
        return d;
    }
};

;// CONCATENATED MODULE: ./src/hooks/useHandlerWhenClickedOutside.tsx


var useHandlerWhenClickedOutside = function(callback) {
    var elementRef = react.useRef(null);
    var handleClickOutside = function(e) {
        if (maybe(function() {
            return elementRef.current && e.target;
        }, null)) {
            if (elementRef.current.contains(e.target)) {
                return;
            }
            callback();
        }
    };
    var setElementRef = function() {
        return elementRef;
    };
    react.useEffect(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return {
        setElementRef: setElementRef
    };
};


/***/ }),

/***/ 83319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; },
/* harmony export */   "k": function() { return /* binding */ useLocalStorageQuiet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function getItem(initialValue, key) {
    var result;
    try {
        var item = window.localStorage.getItem(key);
        result = item ? JSON.parse(item) : initialValue;
    } catch (e) {
        result = initialValue;
    }
    return result;
}
function storeValue(valueToStore, key) {
    try {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (e) {
        // eslint-disable-next-line
        console.warn("Could not save ".concat(key, " to localStorage"));
    }
}
function useLocalStorage(key, initialValue) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return getItem(initialValue, key);
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(value) {
        var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value, Function) ? value(storedValue) : value;
        setStoredValue(valueToStore);
        storeValue(valueToStore, key);
    };
    return [
        storedValue,
        setValue
    ];
}
// Store in local storage only and do not update component state
function useLocalStorageQuiet(key, initialValue) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return getItem(initialValue, key);
    }), storedValue = ref[0];
    var setValue = function(value) {
        var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value, Function) ? value(storedValue) : value;
        storeValue(valueToStore, key);
    };
    return [
        storedValue,
        setValue
    ];
}


/***/ }),

/***/ 92886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ uniqueByKey; }
/* harmony export */ });
function uniqueByKey(items, key) {
    var map = {};
    var result = [];
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        if (typeof item[key] !== "undefined" && !map[item[key]]) {
            map[item[key]] = true;
            result.push(item);
        }
    }
    return result;
}


/***/ })

}]);